// Mock data for the website

export const mockPrograms = [
  {
    category: 'Ages 10-19',
    title: 'Youth Development',
    description: 'Building future champions through disciplined technique, character development, and fundamental boxing skills for the next generation.'
  },
  {
    category: 'All Levels',
    title: 'Elite Classes',
    description: 'High-intensity heavy bag rounds paired with strength circuits. Built to develop power, stamina, endurance, and total-body performance.'
  }
];

export const mockFacilityImages = [
  {
    image: 'https://images.unsplash.com/photo-1575747515871-2e323827539e',
    label: 'THE MAIN ARENA',
    title: 'Competition Ring'
  },
  {
    image: 'https://images.unsplash.com/photo-1716306886418-f84f6d4c2f3a',
    label: 'POWER ZONE',
    title: 'Heavy Bag Alley'
  },
  {
    image: 'https://images.unsplash.com/photo-1765303215249-fc4a1165580f',
    label: 'TECHNIQUE LAB',
    title: 'Precision Training'
  },
  {
    image: 'https://images.unsplash.com/photo-1599058917212-d750089bc07e',
    label: 'THE IRON PIT',
    title: 'Strength & Conditioning'
  },
  {
    image: 'https://images.unsplash.com/photo-1601422407692-ec4eeec1d9b3',
    label: 'WARRIOR SQUAD',
    title: 'Group Training Sessions'
  },
  {
    image: 'https://images.unsplash.com/photo-1716307043003-dbe6a5cc496e',
    label: 'RECOVERY BAY',
    title: 'Athlete Facilities'
  }
];

export const mockTestimonials = [
  {
    name: 'Atang Kgosibodiba',
    program: 'ELITE CLASSES',
    quote: 'Bond Boxing Gym has great trainers and a friendly, motivating atmosphere.'
  },
  {
    name: 'Boipelo Pheresi',
    program: 'ADVANCED TRAINING',
    quote: 'An amazing place to train! The coaches are knowledgeable, supportive, and push you to improve. The gym has a great atmosphere, welcoming for all levels.'
  },
  {
    name: 'Phingie Mothusi',
    program: 'COMPETITIVE TRAINING',
    quote: 'Very dedicated coaches and personal trainers who are always ready to assist.'
  }
];
